import React from 'react';
import { EventDetailResponse } from '../models/api';
import DeleteButton from './DeleteButton';
import Button from './Button';
import { FaEllipsisH } from 'react-icons/fa';
import { ReactComponent as CalendarTodayIcon } from '../assets/calendar_today_large.svg';
import { ReactComponent as DeleteIcon } from '../assets/delete_large.svg';
import { ReactComponent as EditIcon } from '../assets/edit_large.svg';
import { ReactComponent as ShareIcon } from '../assets/ios_share_large.svg';
import { ReactComponent as PresentIcon } from '../assets/present_to_all_large.svg';
import { FeatureGate } from './FeatureGate';

type Props = {
  index: number;
  selectedIndex: number | null;
  sessionDetails: EventDetailResponse;
  onToggle: ((index: number) => void) | ((index: number) => Promise<void>);
  onEdit:
    | ((sessionDetails: EventDetailResponse) => void)
    | ((sessionDetails: EventDetailResponse) => Promise<void>);
  navigateToShowings:
    | ((sessionDetails: EventDetailResponse) => void)
    | ((sessionDetails: EventDetailResponse) => Promise<void>);
  onShare:
    | ((sessionDetails: EventDetailResponse) => void)
    | ((sessionDetails: EventDetailResponse) => Promise<void>);
  navigateToPresent:
    | ((sessionDetails: EventDetailResponse) => void)
    | ((sessionDetails: EventDetailResponse) => Promise<void>);
  onDelete:
    | ((sessionDetails: EventDetailResponse) => void)
    | ((sessionDetails: EventDetailResponse) => Promise<void>);
  deleteLoading: string[];
};

const EventContextMenu: React.FC<Props> = ({
  index,
  selectedIndex,
  sessionDetails,
  onDelete,
  onEdit,
  onShare,
  onToggle,
  navigateToPresent,
  navigateToShowings,
  deleteLoading
}) => {
  return (
    <>
      <Button
        isIcon={true}
        className="menu-button"
        onClick={() => onToggle(index)}
      >
        <FaEllipsisH />
      </Button>
      {selectedIndex === index && (
        <div className="card-menu">
          <Button
            className="card-menu-item"
            onClick={() => onEdit(sessionDetails)}
          >
            <EditIcon />
            Edit
          </Button>
          <FeatureGate feature="MultipleShowings">
            <Button
              className="card-menu-item"
              onClick={() => navigateToShowings(sessionDetails)}
            >
              <CalendarTodayIcon /> Showings
            </Button>
          </FeatureGate>
          <Button
            className="card-menu-item"
            onClick={() => onShare(sessionDetails)}
          >
            <ShareIcon />
            Share
          </Button>
          <Button
            className="card-menu-item"
            onClick={() => navigateToPresent(sessionDetails)}
          >
            <PresentIcon /> Present
          </Button>
          <hr />
          <DeleteButton
            isLoading={deleteLoading.includes(sessionDetails.reference)}
            onClick={() => onDelete(sessionDetails)}
            className="card-menu-item delete"
            message="Are you sure you want to delete this event?"
          >
            <DeleteIcon /> Delete
          </DeleteButton>
        </div>
      )}
    </>
  );
};

export default EventContextMenu;
